export default {
  getWasteGroupSynonyms(state) {
    return state.wasteGroupSynonyms
  },
  getActiveSynonym(state) {
    return state.activeSynonym
  },
  getActiveWasteType(state) {
    return state.activeWasteType
  },
  getWasteStreams(state) {
    return state.wasteStreams
  },
  getActiveWasteStreamId(state) {
    return state.activeWasteStreamId
  },
  isWasteStream(state) {
    return state.isWasteStream
  },
  getActiveWasteStream(state) {
    return state.wasteStreams.find(item => item.id === state.activeWasteStreamId)
  },
  getShowResults(state) {
    return state.showResults
  }
}
